import React from "react";

const HeaderUsageContext = React.createContext<HeaderUsageContextType>(null);

export type HeaderUsageContextType = {
  useUpper: boolean,
  useLower: boolean,
  useSearchBar: boolean, setUseSearchBar: Function,
  useAvatar: boolean, setUseAvatar: Function,
}
export { HeaderUsageContext };
